import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Spacing } from "@snapchat/snap-design-system";

export const VisibilityContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 ${Spacing["1XS"]}px;
`;

export const VisibilityText = styled.span`
    align-self: flex-start;
`;

export const icon = css`
    margin-top: 3px;
`;
